import React from "react"
import Article from '../Article'

function BestPratices(props) {

  const content = `<p><strong>&bull; Salvar o link/endere&ccedil;o na &aacute;rea de trabalho;<br />
  
  &bull; Salvar link/endere&ccedil;o, em configura&ccedil;&otilde;es do Chrome, na p&aacute;gina inicial do navegador e marcar a op&ccedil;&atilde;o &ldquo;abrir onde eu parei&rdquo;.&nbsp;<br />
  &bull; Salvar link/endere&ccedil;o em favoritos.<br />
  &bull; Sempre finalizar a navega&ccedil;&atilde;o de um usu&aacute;rio na op&ccedil;&atilde;o sair.</strong></p>`

  return (
    <Article article={content} title='Melhores práticas de uso' />
    )
  
}

export default BestPratices
